/**
 * SP3 (Mail-UI-Feinschliff) — Bereinigung des Listen-Previews.
 *
 * Graph liefert `bodyPreview` ungefiltert: bei Antworten bluten Quoted-Reply-
 * Artefakte in den Snippet — die Outlook-Trennlinie („________"), die zitierte
 * Kopfzeile („Von: … Gesendet: …" bzw. „From: …") oder der klassische
 * „-----Ursprüngliche Nachricht-----"-Block (Screenshot-Befund 02.23.21).
 * Der Snippet soll nur den eigentlichen Antworttext zeigen.
 *
 * Bewusst pur und DOM-frei → läuft im Node-Test-Runner (mailPreview.test.ts).
 */

/**
 * Artefakt-Marker, ab denen der Preview abgeschnitten wird. „Von:"/„From:"
 * nur am ZEILENanfang — ein „von:" mitten im Satz ist kein Quote-Header.
 */
const CUT_PATTERNS: RegExp[] = [
    /_{3,}/, // Outlook-Trennlinie „________________________________"
    /(?:^|\n)\s*Von:\s/, // zitierte deutsche Kopfzeile (Groß-V, wie Outlook sie schreibt)
    /(?:^|\n)\s*From:\s/, // zitierte englische Kopfzeile
    /-{2,}\s*Ursprüngliche Nachricht\s*-{2,}/i,
    /-{2,}\s*Original Message\s*-{2,}/i,
];

/**
 * Schneidet den Preview am FRÜHESTEN Artefakt-Marker ab und kollabiert
 * Zeilenumbrüche/Mehrfach-Whitespace für die einzeilige Snippet-Anzeige.
 * Besteht der Preview NUR aus zitiertem Inhalt, bleibt bewusst "" übrig
 * (leerer Snippet statt Quote-Kopfzeile).
 */
export function cleanMailPreview(raw: string | null | undefined): string {
    const text = raw ?? "";
    let cut = text.length;
    for (const re of CUT_PATTERNS) {
        const m = re.exec(text);
        if (m && m.index < cut) cut = m.index;
    }
    return text.slice(0, cut).replace(/\s+/g, " ").trim();
}
